export const userRoleTypes = {
  ADMIN: "admin",
  GUEST: "guest",
  AGENT: "agent",
  SUPERVISOR_AGENT: "supervisorAgent",
  CUSTOMER: "customer",
  OPERATOR: "operator",
  AMEX_LIFESTYLE_AGENT: "amex_lifestyleAgent",
};
